import { _, $, Backbone, Radio, Foundation, moment } from "../../../vendor";
import { Backform, Biscuit, FormatHelper, Notification } from "../../utils";
import OffCanvasAddPaymentTpl from "../../templates/orders/OffCanvasAddPaymentTpl.html";
import InboomaBaseView from "../InboomaBaseView";

import OffCanvasBehavior from "../../behaviors/Behavior.OffCanvas";

import InboomaBaseAsyncCollection from "../../collections/InboomaBaseAsyncCollection";
import Order from "../../models/Order";

export default InboomaBaseView.extend({
  template: OffCanvasAddPaymentTpl,
  el: "#inb-off-canvas",
  parentView: "orders",
  skipValidation: false,

  behaviors: [
    {
      behaviorClass: OffCanvasBehavior,
      closeAfterSave: false,
    },
  ],

  events: {
    "click #save-payment": "_savePayment",
    "click #add-dynamic-payment": "_addPayment",
    "click .inb-fi-refund": "_returnPayment",
  },

  templateContext() {
    return {
      moment,
      locations: Radio.channel("locationsWithTrashed").request("get:data"),
      currency: Biscuit.getClientCurrency(),
      transactions: this.model.get("transactions"),
      confirm_order: this.model.get("confirm_order"),
      isOnlinePayment: (transaction) => {
        return transaction.online;
      },
      FormatHelper: FormatHelper,
      context: this.options.context,
      metaData: (transaction) => {
        if (typeof transaction.meta.type !== "undefined") {
          switch (transaction.meta.type) {
            case "PayPal":
              if (transaction.meta.status == "ERROR") {
                return (
                  (typeof transaction.meta.name !== "undefined" &&
                  typeof transaction.meta.email !== "undefined"
                    ? transaction.meta.name + " (" + transaction.meta.email + ")" + "<br/>"
                    : "") + transaction.meta.message
                );
              }
              return typeof transaction.meta.name !== "undefined" &&
                transaction.meta.name !== null &&
                typeof transaction.meta.email !== "undefined" &&
                transaction.meta.email !== null
                ? transaction.meta.name + " (" + transaction.meta.email + ")"
                : "";
              break;
            case "credit":
              if (transaction.meta.status == "ERROR") {
                return (
                  (typeof transaction.meta.brand !== "undefined" &&
                  typeof transaction.meta.reference !== "undefined"
                    ? transaction.meta.brand + " " + transaction.meta.reference + "<br/>"
                    : "") + transaction.meta.message
                );
              }
              return typeof transaction.meta.brand !== "undefined" &&
                transaction.meta.brand !== null &&
                typeof transaction.meta.reference !== "undefined" &&
                transaction.meta.reference !== null
                ? transaction.meta.brand + " " + transaction.meta.reference
                : "";
              break;
            case "applePay":
              if (transaction.meta.status == "ERROR") {
                return (
                  (typeof transaction.meta.brand !== "undefined" &&
                  typeof transaction.meta.reference !== "undefined"
                    ? transaction.meta.brand + " " + transaction.meta.reference + "<br/>"
                    : "") + transaction.meta.message
                );
              }
              return typeof transaction.meta.brand !== "undefined" &&
                typeof transaction.meta.reference !== "undefined"
                ? transaction.meta.brand + " " + transaction.meta.reference
                : "";
              break;
            case "googlePay":
              if (transaction.meta.status == "ERROR") {
                return (
                  (typeof transaction.meta.brand !== "undefined" &&
                  typeof transaction.meta.reference !== "undefined"
                    ? transaction.meta.brand + " " + transaction.meta.reference + "<br/>"
                    : "") + transaction.meta.message
                );
              }
              return typeof transaction.meta.brand !== "undefined" &&
                typeof transaction.meta.reference !== "undefined"
                ? transaction.meta.brand + " " + transaction.meta.reference
                : "";
              break;
            case "sepa_debit":
              if (transaction.meta.status == "ERROR") {
                return (
                  (typeof transaction.meta.brand !== "undefined" &&
                  typeof transaction.meta.reference !== "undefined"
                    ? transaction.meta.brand + " " + transaction.meta.reference + "<br/>"
                    : "") + transaction.meta.message
                );
              }
              return typeof transaction.meta.brand !== "undefined" &&
                typeof transaction.meta.reference !== "undefined"
                ? transaction.meta.brand + " " + transaction.meta.reference
                : "";
              break;
            case "Voucher":
              return transaction.meta.reference;
              break;
          }
        }
        return null;
      },
      //'order': this.model.get('orderId'),
    };
  },

  _returnPayment(ev) {
    console.log("return payment clicked: ", ev.target);

    console.log("attr: ", ev.target.getAttribute("inb-val"));

    console.log("model transactions: ", this.model.get("transactions"));

    //ev.stopImmediatePropagation();

    const PaymentRequest = Backbone.Model.extend({
      urlRoot: "/payments/refund",
      defaults: {
        type: "",
        amount: "",
        transactionId: "",
        userId: "",
      },
    });

    const that = this;

    if (this._refundTriggered === true) return;
    else this._refundTriggered = true;

    _.each(this.model.get("transactions"), function (transaction) {
      if (Number(transaction.id) === Number(ev.target.getAttribute("inb-val"))) {
        let paymentRequest = new PaymentRequest();

        console.log("MODEL: ", that.model);

        //paymentRequest.set('type', transaction.payment_type);
        paymentRequest.set("amount", transaction.credit);
        paymentRequest.set("transactionId", transaction.reference);

        if (transaction.payment_type == "PayPal") {
          paymentRequest.set("type", "paypal");
        } else {
          paymentRequest.set("type", "stripe");
        }

        if (
          typeof transaction.accumulated_invoice_id === "undefined" ||
          transaction.accumulated_invoice_id === null
        ) {
          paymentRequest.set("orderId", transaction.order_id);
        } else {
          paymentRequest.set("accumulatedInvoiceId", transaction.accumulated_invoice_id);
        }

        if (that.model.get("user_id") !== null) {
          paymentRequest.set("userId", that.model.get("user_id"));
        }

        console.log(paymentRequest.toJSON());

        paymentRequest.save(null, {
          silent: true,
          type: "POST",
          success(model, response) {
            if (response.success) {
              new Notification({
                message: that.t("refund_success"),
                duration: 5000,
                type: "success",
                closeable: true,
                icon: "fi fi-credit-card",
              });

              that._setPaymentList();

              $("div.inb-loader.inb-loader--small").addClass("hide");
            } else {
              console.log("could not execute refund");
            }
            that._refundTriggered = false;
          },
          error(model, response) {
            new Notification({
              message: that.t("payment_error"),
              duration: 5000,
              type: "error",
              closeable: true,
              icon: "fi fi-x",
            });

            that._setPaymentList();

            that._refundTriggered = false;

            $("div.inb-loader.inb-loader--small").addClass("hide");
          },
        });
      }
    });
  },

  _addPayment(ev) {
    // $('#reservations-list').removeClass('hide');
    const locations = Radio.channel("locationsWithTrashed").request("get:data");

    // Show select box of all locations connected to order.reservations
    let orderHasLocations = {},
      formattedLocations = [];

    _.each(this.model.get("reservations").models, function (reservation) {
      orderHasLocations[reservation.get("begin_location")] = true;
      orderHasLocations[reservation.get("end_location")] = true;
    });

    if (Biscuit.get("user.role") != "manager-location") formattedLocations.push("");

    _.each(orderHasLocations, function (__, id) {
      const location = locations.get(id);

      if (typeof location !== "undefined") {
        formattedLocations.push({ label: location.get("name"), value: location.id });
      }
    });

    let amount_to_be_paid = Number(this.model.get("order_due"));

    const that = this;

    let fields = [];
    console.log("model: ", this.model);
    if (that.model.get("id") != "") {
      // Force formatting
      this.model.set("price", this.model.get("price"));
      this.model.set("currency", "  " + Biscuit.getClientCurrency());
      fields.push(
        {
          // formatter: Number(event.price).toLocaleString("es-ES", {minimumFractionDigits: 2})
          name: "amount",
          required: true,
          control: "input",
          size: {
            large: "",
            small: "2",
          },
        },
        {
          // formatter: Number(event.price).toLocaleString("es-ES", {minimumFractionDigits: 2})
          name: "currency",
          disabled: true,
          control: "input",
          size: {
            large: "",
            small: "1",
          },
        },
        {
          name: "payment_type",
          required: true,
          control: "select",
          size: {
            large: "",
            small: "3",
          },
          options: _.map(that.model.get("payment_types"), (payment_type, key) => {
            return {
              label: "Offline-Zahlung" + " " + that.t(payment_type, null, "capital"),
              value: payment_type,
            };
          }),
        },
        {
          // formatter: Number(event.price).toLocaleString("es-ES", {minimumFractionDigits: 2})
          name: "date",
          required: true,
          control: "datepicker",
          displayIcon: false,
          extraTopClasses: ["hide-group-label restype-1 restype-2 restype-3"],
          //value: moment(this.model.get('date')).format('dd/mm/YY'),
          size: {
            large: "2",
            medium: "2",
            small: "3",
          },
        },
        {
          // formatter: Number(event.price).toLocaleString("es-ES", {minimumFractionDigits: 2})
          name: "time",
          required: true,
          control: "input",
          type: "time",
          displayIcon: false,
          value: moment(new Date()).format("HH:mm"),
          size: {
            large: "1",
            medium: "1",
            small: "3",
          },
        },
        {
          name: "location",
          required: true,
          control: "select",
          size: {
            large: "",
            small: "3",
          },
          options: formattedLocations,
        },
      );
    }

    $("#save-payment").removeClass("disabled");

    this.form = new Backform.Form({
      el: that.$el.find("#orders-form"),
      model: that.model,
      fields,
    }).render();
    new Foundation.Abide(that.$el.find("#orders-form"), {
      liveValidate: true,
    });
  },

  _savePayment(ev) {
    ev.preventDefault();
    if (ev.target.className.indexOf("disabled") > 0) return;
    ev.returnValue = false;

    $("div.inb-loader.inb-loader--small").removeClass("hide");

    const amount = Number($("#orders-form").find('input[name="amount"]').val().replace(",", "."));

    if (amount === null || amount === 0 || amount === "" || isNaN(amount)) {
      $("#orders-form").find('input[name="amount"]').css("border-color", "red");
      // $('#save-payment').attr('disabled', 'true');
      $("div.inb-loader.inb-loader--small").addClass("hide");

      return false;
    } else {
      $("#orders-form").find('input[name="amount"]').css("border-color", "#e3e3e3");
    }

    // @todo The following lines are not actually required as
    // the model is managed via backform. However, as several default
    // values are missing in this.model.attributes (and would therefore be "undefined"),
    // we leave it as it is

    let payment_type = $("#orders-form").find('select[name="payment_type"]').val();
    payment_type = payment_type.slice(1, payment_type.length - 1);
    const date = $("#orders-form").find('input[name="date"]').val();
    const time = $("#orders-form").find('input[name="time"]').val();
    const payment_date = moment(date, "D. MMMM YYYY").format("YYYY-MM-DD") + " " + time;
    console.log(time);
    const location_id = Number($("#orders-form").find('select[name="location"]').val());
    const order_id = this.model.id;

    const PaymentRequest = Backbone.Model.extend({
      //urlRoot: '/payments/cashCheckout',
      urlRoot: "/payments",
      defaults: {
        id: "",
        order_id: "",
        amount: "",
        payment_type: "",
        payment_date: "",
      },
    });

    if ($("#save-payment")) {
      const that = this;

      let paymentRequest = new PaymentRequest();

      if (typeof this._alreadyShowedExecuteWarning !== "undefined") {
        delete this._alreadyShowedExecuteWarning;
        return;
      }

      this._alreadyShowedExecuteWarning = true;
      // console.log(payment_date);

      /*paymentRequest.set({
                'order_id' : this.model.get('id'),
                'location_id' : Number(this.model.get('location')),
                'amount' : this.model.get('amount'),
                'payment_type' : this.model.get('payment_type'),
                'payment_date' : this.model.get('date')
            });*/

      paymentRequest.set("order_id", order_id);
      if (location_id != "") paymentRequest.set("location_id", location_id);
      paymentRequest.set("amount", amount);
      paymentRequest.set("payment_type", payment_type);
      paymentRequest.set("payment_date", payment_date);

      console.log(paymentRequest.toJSON());

      // @todo Enrich error notification message with specific error-code

      paymentRequest.save(null, {
        silent: true,
        type: "POST",
        success(model, response) {
          if (response.success) {
            new Notification({
              message: that.t("payment_success"),
              duration: 5000,
              type: "success",
              closeable: true,
              icon: "fi fi-credit-card",
            });

            that._setPaymentList();

            $("div.inb-loader.inb-loader--small").addClass("hide");
            $("#save-payment").addClass("disabled");
          } else {
            console.log("data did not save");
          }
        },
        error(model, response) {
          new Notification({
            message: that.t("payment_error"),
            duration: 5000,
            type: "error",
            closeable: true,
            icon: "fi fi-x",
          });

          that._setPaymentList();

          $("div.inb-loader.inb-loader--small").addClass("hide");
        },
      });
    } else {
      const that = this;
      if (typeof this._alreadyExecuted !== "undefined") {
        return;
      }
      this._alreadyExecuted = true;
      that.render();
      return;
    }
  },

  _setPaymentList() {
    const that = this;

    if (typeof this.options.orderId === "undefined") {
      this.options.orderId = this.options.model.id;
    }

    const PaymentLists = InboomaBaseAsyncCollection.extend({
      url: "/payments/orderpaymentlists/" + this.options.orderId,
    });

    let payments = new PaymentLists().fetch({
      async: false,
      silent: true,
      type: "POST",
      contentType: "application/json",
      accept: "application/json",
      success(model, response) {
        console.log("order_due: ", response.data.order_due);
        that.model.set({
          transactions: response.data.payment_lists,
          amount: response.data.order_due,
          payment_types: response.data.payment_types,
        });

        if (response.data.order_due === 0) {
          that.model.set("confirm_order", 1);
        } else if (response.data.order_due < 0) {
          that.model.set("amount", 0);
        }
        that.model.set("time", moment().format("HH:mm"));

        that.render();
      },

      error() {
        that.render();
      },
    });
  },

  initialize() {
    const currentUrl = new URL(window.location.href);
    if (typeof this.options.context != "undefined") {
      this.parentView = this.options.context + currentUrl.search;
    }

    if (typeof this.model === "undefined") {
      //this.model = this.collection.fetchById(this.orderId);
    }

    //this.model.set('confirm_order', 0);
    this.afterCloseTriggerNavigate = true;
    // const orderdue = this.model.price;

    this._setPaymentList();
  },

  onRender() {},
});
